import axios from 'axios';

const $axios = axios.create({
  baseURL: process.env.RAZZLE_API_URL,
});

$axios.interceptors.request.use(
  (config) => {
    const c = { ...config };
    // Legacy paths starting with /api/ were rewritten by the old Koa proxy that
    // stripped /api before forwarding. We replicate that here so call sites stay
    // unchanged across the codebase.
    if (typeof c.url === 'string' && c.url.startsWith('/api/')) {
      c.url = c.url.replace(/^\/api/, '');
    }
    if (typeof window !== 'undefined' && window.localStorage) {
      const token = window.localStorage.getItem('sessionId');
      if (token) {
        c.headers = { ...c.headers, Authorization: `Bearer ${token}` };
      }
    }
    return c;
  },
  error => Promise.reject(error),
);

$axios.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
);

export default $axios;
